module.exports = __webpack_public_path__ + "static/media/face-recognization-01.ef710a46.jpg";